export const OperatorForm: ng.IComponentOptions = {
  bindings: {
    model: '=',
    name: '=',
    tradingName: '=',
    externalReferences: '='
  },
  templateUrl: 'app/angularJS/components/forms/operator/operator-form.html',
  controller: 'OperatorFormController',
  controllerAs: 'vm'
};